import AllApplication from './allApplication';
export default AllApplication;